import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahServiceWraps } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import type { SahServiceWrap } from '~lookups/models';

export const typePrefix = 'sah-service-wraps';

export const sahServiceWrapsApi = createApi({
  reducerPath: 'sahServiceWrapsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahServiceWraps }),
  tagTypes: ['sah-service-wraps'],
  endpoints: (builder) => ({
    getSahServiceWraps: builder.query<SahServiceWrap[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'sah-service-wraps', id: 'LIST' }],
      transformResponse: (payload) => unwrap<SahServiceWrap[]>(payload),
    }),
  }),
});

export const { useGetSahServiceWrapsQuery } = sahServiceWrapsApi;
